import type { Disposable } from '@patsnap/tahiti-core';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import {
    ReportGenerationStatusService,
    type ReportGenerationStatusService as ReportGenerationStatusServiceType,
} from '@/domains/novelty-check-report/services/report-generation-status-service';
import { CurrentTaskService, type CurrentTaskService as CurrentTaskServiceType } from '@/services/current-task/current-task-service';
import {
    FirstTaskRewardService,
    type FirstTaskRewardService as FirstTaskRewardServiceType,
} from '../../first-task-reward/first-task-reward-service';
import type { NoveltySearchReportValueOnboardingService } from '../novelty-search-report-value-onboarding-service';

/** 将查新报告真实完成事件转交给统一首次任务奖励服务。 */
@injectable()
export class NoveltySearchReportValueOnboardingServiceImpl implements NoveltySearchReportValueOnboardingService {
    private _isInitialized = false;
    private _reportGeneratedDisposable?: Disposable;

    constructor(
        @inject(ReportGenerationStatusService)
        private readonly _reportGenerationStatusService: ReportGenerationStatusServiceType,
        @inject(CurrentTaskService)
        private readonly _currentTaskService: CurrentTaskServiceType,
        @inject(FirstTaskRewardService)
        private readonly _rewardService: FirstTaskRewardServiceType,
    ) {}

    async initialize(): Promise<void> {
        if (this._isInitialized) return;
        this._isInitialized = true;
        this._reportGeneratedDisposable = this._reportGenerationStatusService.onReportGenerated(
            this._handleReportGenerated,
        );
    }

    debugStart(taskId: string): void {
        if (!import.meta.env.DEV || !taskId) return;
        this._start(taskId);
    }

    destroy(): void {
        this._isInitialized = false;
        this._reportGeneratedDisposable?.dispose();
        this._reportGeneratedDisposable = undefined;
        this._rewardService.destroyReport();
    }

    private readonly _handleReportGenerated = () => {
        if (this._isInitialized) this._start(this._currentTaskService.taskId);
    };

    private _start(taskId: string): void {
        this._rewardService.startReport({
            taskId,
            agentType: 'NOVELTY_SEARCH',
            reportSelector: '[data-testid="novelty-search-report-content"]',
            shareSelector: '[data-testid="share-link-button"]',
            exportSelector: '[data-testid="novelty-search-report-export"]',
        });
    }
}
